import Sortable from "sortablejs"

export function initSortable(
  elementContainer,
  draggableSelector,
  dragHandleSelector,
  callbackMethod
) {
  return new Sortable(elementContainer, {
    draggable: draggableSelector,
    handle: dragHandleSelector,
    chosenClass: "chosen-draggable",
    ghostClass: "ghost-draggable",
    onSort: function () {
      callbackMethod()
    },
  })
}
